import type { AuthContextType } from "@/types/auth-type";
import { createContext } from "react";

export const AuthContext = createContext<AuthContextType | undefined>(
    undefined,
);
